import {
  Box,
  Button,
  Flex,
  HStack,
  VStack,
  Image,
  Text,
  Badge,
  Divider,
  Container,
  Icon,
} from "@chakra-ui/react";
import { CheckIcon } from "@chakra-ui/icons";
import { useContext, useEffect, useState } from "react";
import { CartContext } from "../Context/CartContext";
import { MdSecurity, MdLocalShipping, MdVerifiedUser } from "react-icons/md";
import { FiChevronRight, FiEdit2, FiArrowLeft } from "react-icons/fi";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { apiUrl } from "../ApiUrl/ApiUrl";

function Summary() {
  let sellingPrice = 0;
  let discount = 0;
  let totalAmount = 0;

  const [totalDescPrice, setTotalDescPrice] = useState(0);
  const [totalOrigPrice, setTotalOrigPrice] = useState(0);
  const [gst, setGst] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { cartData, globalAddress } = useContext(CartContext);
  const navigate = useNavigate();

  cartData.forEach(() => {
    sellingPrice = totalOrigPrice;
    discount = totalOrigPrice - totalDescPrice;
    totalAmount = sellingPrice - discount + gst;
  });

  function getprice() {
    const uid = localStorage.getItem("uid");

    fetch(`${apiUrl}/public/getAllCartById?uid=${uid}`)
      .then((res) => res.json())
      .then((res) => {
        const total = res.reduce(
          (sum, item) => sum + parseFloat(item.descprice || 0),
          0
        );
        const totalGst = res.reduce(
          (sum, item) => sum + parseFloat(item.gst || 0),
          0
        );

        setGst(totalGst);
        const originaltotal = res.reduce(
          (sum, item) =>
            sum + (item.quantity || 1) * parseFloat(item.originalprice || 0),
          0
        );
        setTotalDescPrice(total);
        setTotalOrigPrice(originaltotal);
      })
      .catch((error) => {
        console.error("Error fetching price details:", error);
      });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getprice();
  }, []);

  if (cartData.length === 0) {
    return <Navigate to="/cart" />;
  }

  const handelClickRazorpay = () => {
    setIsSubmitting(true);
    localStorage.setItem("apiUrl", apiUrl);
    const uid = localStorage.getItem("uid");
    const email = localStorage.getItem("email");

    fetch(`${apiUrl}/public/api/payment/create-order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        order_id: localStorage.getItem("order_id"),
        amount: totalAmount,
        customer_id: uid,
        customer_email: email,
        cid: uid,
      }),
    })
      .then(async (response) => {
        const text = await response.text();
        try {
          return JSON.parse(text);
        } catch (e) {
          console.error("Non-JSON response from create-order:", text);
          return { error: text };
        }
      })
      .then((data) => {
        if (data && data.id) {
          localStorage.setItem("order_response_id", data.id);
        } else if (data && data.error) {
          console.error("Razorpay order creation error:", data.error);
        }
        navigate("/payment");
      })
      .catch((error) => {
        console.error("Error creating Razorpay order:", error);
        navigate("/payment");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const userName = localStorage.getItem("name") || localStorage.getItem("loginsetName") || "Valued Customer";
  const userEmail = localStorage.getItem("email") || localStorage.getItem("username") || "";

  return (
    <Box bg="#F8FAFC" minH="90vh" py={{ base: 4, md: 8 }}>
      <Container maxW="1200px" px={{ base: 3, md: 6 }}>
        {/* Checkout Header Progress */}
        <Flex
          justify="space-between"
          align="center"
          mb={{ base: 5, md: 8 }}
          bg="white"
          p={{ base: 3, md: 4 }}
          rounded="xl"
          shadow="xs"
          border="1px solid"
          borderColor="gray.200"
          overflowX="auto"
        >
          <Link to="/cart">
            <HStack spacing={2} minW="fit-content" cursor="pointer" _hover={{ opacity: 0.8 }}>
              <Flex
                w="26px"
                h="26px"
                rounded="full"
                bg="green.500"
                color="white"
                align="center"
                justify="center"
                fontSize="xs"
                fontWeight="bold"
              >
                ✓
              </Flex>
              <Text fontSize="xs" fontWeight="semibold" color="gray.700" _hover={{ color: "#162237" }}>
                1. Cart
              </Text>
            </HStack>
          </Link>
          <Icon as={FiChevronRight} color="gray.400" />
          <Link to="/delivery">
            <HStack spacing={2} minW="fit-content" cursor="pointer" _hover={{ opacity: 0.8 }}>
              <Flex
                w="26px"
                h="26px"
                rounded="full"
                bg="green.500"
                color="white"
                align="center"
                justify="center"
                fontSize="xs"
                fontWeight="bold"
              >
                ✓
              </Flex>
              <Text fontSize="xs" fontWeight="semibold" color="gray.700" _hover={{ color: "#162237" }}>
                2. Address
              </Text>
            </HStack>
          </Link>
          <Icon as={FiChevronRight} color="gray.400" />
          <HStack spacing={2} minW="fit-content">
            <Flex
              w="26px"
              h="26px"
              rounded="full"
              bg="#162237"
              color="#EAB308"
              align="center"
              justify="center"
              fontSize="xs"
              fontWeight="bold"
            >
              3
            </Flex>
            <Text fontSize="xs" fontWeight="bold" color="#162237">
              3. Summary
            </Text>
          </HStack>
          <Icon as={FiChevronRight} color="gray.400" />
          <HStack spacing={2} minW="fit-content" opacity={0.6}>
            <Flex
              w="26px"
              h="26px"
              rounded="full"
              bg="gray.200"
              color="gray.600"
              align="center"
              justify="center"
              fontSize="xs"
              fontWeight="bold"
            >
              4
            </Flex>
            <Text fontSize="xs" fontWeight="medium" color="gray.500">
              4. Payment
            </Text>
          </HStack>
        </Flex>

        {/* Main Grid */}
        <Flex
          direction={{ base: "column", lg: "row" }}
          gap={{ base: 6, lg: 8 }}
          align="flex-start"
        >
          {/* Left Column: Steps */}
          <VStack w={{ base: "100%", lg: "68%" }} spacing={4} align="stretch">
            {/* Step 1: Login Complete */}
            <Box
              bg="white"
              rounded="xl"
              border="1px solid"
              borderColor="gray.200"
              p={{ base: 4, md: 5 }}
              shadow="xs"
            >
              <Flex justify="space-between" align="center">
                <HStack spacing={3}>
                  <Flex
                    w="24px"
                    h="24px"
                    rounded="full"
                    bg="green.50"
                    color="green.600"
                    align="center"
                    justify="center"
                    fontSize="xs"
                    fontWeight="bold"
                  >
                    ✓
                  </Flex>
                  <Box>
                    <Text fontSize="xs" color="gray.500" fontWeight="bold" textTransform="uppercase" letterSpacing="wide">
                      Step 1: Account
                    </Text>
                    <Text fontSize="sm" fontWeight="semibold" color="gray.800">
                      {userName} {userEmail && <Text as="span" color="gray.500" fontWeight="normal">({userEmail})</Text>}
                    </Text>
                  </Box>
                </HStack>
                <Badge colorScheme="green" fontSize="xs" px={2} py={0.5} rounded="md">
                  Active
                </Badge>
              </Flex>
            </Box>

            {/* Step 2: Delivery Address Complete */}
            <Box
              bg="white"
              rounded="xl"
              border="1px solid"
              borderColor="gray.200"
              p={{ base: 4, md: 5 }}
              shadow="xs"
            >
              <Flex justify="space-between" align="flex-start" gap={3}>
                <HStack spacing={3} align="flex-start">
                  <Flex
                    w="24px"
                    h="24px"
                    rounded="full"
                    bg="green.50"
                    color="green.600"
                    align="center"
                    justify="center"
                    fontSize="xs"
                    fontWeight="bold"
                    mt={0.5}
                  >
                    ✓
                  </Flex>
                  <Box>
                    <Text fontSize="xs" color="gray.500" fontWeight="bold" textTransform="uppercase" letterSpacing="wide">
                      Step 2: Delivery Address
                    </Text>
                    <Text fontSize="sm" fontWeight="bold" color="gray.900" mt={0.5}>
                      {globalAddress.Name || "Registered Customer"}
                    </Text>
                    <Text fontSize="xs" color="gray.600" mt={0.5} maxW="450px" lineHeight="tall">
                      {globalAddress.Address ? `${globalAddress.Address}, ${globalAddress.City} - ${globalAddress.Pincode}` : "Default Delivery Address Selected"}
                    </Text>
                  </Box>
                </HStack>

                <Link to="/delivery">
                  <Button
                    size="sm"
                    variant="outline"
                    borderColor="#162237"
                    color="#162237"
                    _hover={{ bg: "#162237", color: "white" }}
                    leftIcon={<FiEdit2 />}
                    rounded="lg"
                    fontWeight="bold"
                    px={3}
                  >
                    Change Address
                  </Button>
                </Link>
              </Flex>
            </Box>

            {/* Quick Navigation Back Bar */}
            <HStack justify="space-between" align="center" px={1} py={1}>
              <Link to="/delivery">
                <Button
                  size="sm"
                  variant="ghost"
                  color="#162237"
                  _hover={{ bg: "gray.100" }}
                  leftIcon={<FiArrowLeft />}
                  fontWeight="bold"
                >
                  ← Back to Delivery Address
                </Button>
              </Link>
              <Link to="/cart">
                <Text fontSize="xs" color="blue.600" textDecoration="underline" cursor="pointer">
                  ← Back to Shopping Cart
                </Text>
              </Link>
            </HStack>

            {/* Step 3: Active Order Summary */}
            <Box
              bg="white"
              rounded="xl"
              border="1px solid"
              borderColor="#162237"
              shadow="sm"
              overflow="hidden"
            >
              {/* Active Step Bar */}
              <Flex
                bg="#162237"
                color="white"
                px={{ base: 4, md: 5 }}
                py={3.5}
                align="center"
                justify="space-between"
              >
                <HStack spacing={3}>
                  <Flex
                    w="26px"
                    h="26px"
                    rounded="full"
                    bg="#EAB308"
                    color="#0F172A"
                    align="center"
                    justify="center"
                    fontSize="xs"
                    fontWeight="bold"
                  >
                    3
                  </Flex>
                  <Text fontSize="sm" fontWeight="bold" letterSpacing="wide">
                    ORDER SUMMARY & REVIEW
                  </Text>
                </HStack>
                <Badge bg="whiteAlpha.200" color="#EAB308" px={2.5} py={0.5} rounded="md" fontSize="xs">
                  {cartData.length} {cartData.length === 1 ? "Item" : "Items"}
                </Badge>
              </Flex>

              {/* Items List */}
              <VStack spacing={0} align="stretch" divider={<Divider borderColor="gray.100" />}>
                {cartData.map((data, index) => {
                  const itemSavings = data.originalprice && data.descprice
                    ? Math.round(((data.originalprice - data.descprice) / data.originalprice) * 100)
                    : 0;

                  return (
                    <Flex
                      key={data.id || index}
                      p={{ base: 3, md: 5 }}
                      gap={{ base: 3, md: 5 }}
                      align="center"
                      _hover={{ bg: "gray.50" }}
                      transition="background 0.2s"
                    >
                      <Box
                        w={{ base: "75px", md: "90px" }}
                        h={{ base: "95px", md: "110px" }}
                        p={2}
                        bg="white"
                        rounded="lg"
                        border="1px solid"
                        borderColor="gray.200"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexShrink={0}
                      >
                        <Image
                          src={data.imagePath}
                          alt={data.booktitle}
                          maxH="100%"
                          maxW="100%"
                          objectFit="contain"
                          fallbackSrc="https://navneetlawstudio.com/logo.png"
                        />
                      </Box>

                      <Box flex="1" minW="0">
                        <Text
                          fontSize={{ base: "xs", md: "sm" }}
                          fontWeight="bold"
                          color="gray.800"
                          noOfLines={2}
                          lineHeight="snug"
                        >
                          {data.booktitle}
                        </Text>

                        <HStack spacing={2} mt={1} wrap="wrap">
                          {data.maincatname && (
                            <Badge colorScheme="purple" fontSize="10px" rounded="sm">
                              {data.maincatname}
                            </Badge>
                          )}
                          <Badge colorScheme="gray" fontSize="10px" rounded="sm">
                            Qty: {data.quantity || 1}
                          </Badge>
                        </HStack>

                        <HStack spacing={2} mt={2} align="baseline">
                          <Text fontSize={{ base: "sm", md: "md" }} fontWeight="bold" color="#162237">
                            ₹{data.descprice}
                          </Text>
                          {data.originalprice && data.originalprice > data.descprice && (
                            <Text fontSize="xs" color="gray.400" as="del">
                              ₹{data.originalprice}
                            </Text>
                          )}
                          {itemSavings > 0 && (
                            <Badge colorScheme="green" fontSize="10px" px={1.5} rounded="sm">
                              {itemSavings}% OFF
                            </Badge>
                          )}
                        </HStack>
                      </Box>

                      <Box textAlign="right" display={{ base: "none", sm: "block" }}>
                        <Text fontSize="xs" color="gray.500">Subtotal</Text>
                        <Text fontSize="sm" fontWeight="bold" color="gray.800">
                          ₹{Number(data.descprice || 0) * Number(data.quantity || 1)}
                        </Text>
                      </Box>
                    </Flex>
                  );
                })}
              </VStack>

              {/* Notification & Continue Action */}
              <Box
                p={{ base: 4, md: 5 }}
                bg="#F8FAFC"
                borderTop="1px solid"
                borderColor="gray.200"
              >
                <Flex
                  direction={{ base: "column", sm: "row" }}
                  justify="space-between"
                  align={{ base: "stretch", sm: "center" }}
                  gap={4}
                >
                  <HStack spacing={2}>
                    <Icon as={MdVerifiedUser} color="green.600" boxSize={5} />
                    <Text fontSize="xs" color="gray.600">
                      Order confirmation & invoice will be sent to your registered email.
                    </Text>
                  </HStack>

                  <Button
                    size="lg"
                    bg="#fb641b"
                    color="white"
                    _hover={{ bg: "#e65c1b", shadow: "md" }}
                    _active={{ bg: "#cf5317" }}
                    px={8}
                    fontWeight="bold"
                    fontSize="sm"
                    rounded="lg"
                    isLoading={isSubmitting}
                    loadingText="Processing..."
                    onClick={handelClickRazorpay}
                  >
                    CONTINUE TO PAYMENT
                  </Button>
                </Flex>
              </Box>
            </Box>

            {/* Step 4: Payment Options Preview */}
            <Box
              bg="white"
              rounded="xl"
              border="1px solid"
              borderColor="gray.200"
              p={{ base: 4, md: 5 }}
              shadow="xs"
              opacity={0.7}
            >
              <Flex justify="space-between" align="center">
                <HStack spacing={3}>
                  <Flex
                    w="24px"
                    h="24px"
                    rounded="full"
                    bg="gray.100"
                    color="gray.500"
                    align="center"
                    justify="center"
                    fontSize="xs"
                    fontWeight="bold"
                  >
                    4
                  </Flex>
                  <Box>
                    <Text fontSize="xs" color="gray.400" fontWeight="bold" textTransform="uppercase" letterSpacing="wide">
                      Step 4: Payment Method
                    </Text>
                    <Text fontSize="sm" fontWeight="medium" color="gray.600">
                      HDFC Payment Gateway & Razorpay (Cards, UPI, Netbanking)
                    </Text>
                  </Box>
                </HStack>
              </Flex>
            </Box>
          </VStack>

          {/* Right Column: Price Details & Trust */}
          <Box w={{ base: "100%", lg: "32%" }} position={{ lg: "sticky" }} top="24px">
            <Box
              bg="white"
              rounded="xl"
              border="1px solid"
              borderColor="gray.200"
              shadow="xs"
              p={{ base: 4, md: 6 }}
            >
              <Text
                fontSize="xs"
                fontWeight="bold"
                color="gray.500"
                textTransform="uppercase"
                letterSpacing="wider"
                mb={4}
              >
                Price Details ({cartData.length} {cartData.length === 1 ? "Item" : "Items"})
              </Text>

              <VStack spacing={3} align="stretch" fontSize="sm">
                <Flex justify="space-between">
                  <Text color="gray.600">Total MRP</Text>
                  <Text fontWeight="medium" color="gray.800">₹{sellingPrice}</Text>
                </Flex>

                <Flex justify="space-between">
                  <Text color="gray.600">Catalogue Discount</Text>
                  <Text fontWeight="medium" color="green.600">- ₹{discount}</Text>
                </Flex>

                <Flex justify="space-between">
                  <Text color="gray.600">Price After Discount</Text>
                  <Text fontWeight="medium" color="gray.800">₹{sellingPrice - discount}</Text>
                </Flex>

                <Flex justify="space-between" align="center">
                  <Text color="gray.600">Delivery Charges</Text>
                  <HStack spacing={1}>
                    <Text as="del" fontSize="xs" color="gray.400">₹99</Text>
                    <Badge colorScheme="green" fontSize="xs">FREE</Badge>
                  </HStack>
                </Flex>

                <Flex justify="space-between">
                  <Text color="gray.600">Applicable GST</Text>
                  <Text fontWeight="medium" color="gray.800">{gst > 0 ? `₹${gst}` : "₹0"}</Text>
                </Flex>

                <Divider my={2} />

                <Flex justify="space-between" align="baseline">
                  <Text fontSize="md" fontWeight="bold" color="gray.900">Total Payable</Text>
                  <Text fontSize="xl" fontWeight="extrabold" color="#162237">₹{totalAmount}</Text>
                </Flex>
              </VStack>

              {discount > 0 && (
                <Box
                  mt={4}
                  p={2.5}
                  bg="green.50"
                  border="1px solid"
                  borderColor="green.200"
                  rounded="lg"
                  textAlign="center"
                >
                  <Text fontSize="xs" fontWeight="semibold" color="green.700">
                    🎉 You will save ₹{discount} on this purchase!
                  </Text>
                </Box>
              )}

              {/* GST Statutory Information Note */}
              <Box mt={4} p={3} bg="gray.50" rounded="lg" border="1px dashed" borderColor="gray.300">
                <Text fontSize="11px" fontWeight="semibold" color="gray.700" mb={1}>
                  Statutory GST Breakdown:
                </Text>
                <Text fontSize="10px" color="gray.600" lineHeight="tall">
                  • 📚 Law Books & Acts: 0% GST (Exempt)<br />
                  • 💻 Legal Softwares & Subscriptions: 18% GST<br />
                  • 👕 Advocate Apparel: 5% (≤₹1000) / 12% (&gt;₹1000)
                </Text>
              </Box>

              {/* Trust Badges */}
              <VStack spacing={2} align="stretch" mt={5} pt={4} borderTop="1px solid" borderColor="gray.100">
                <HStack spacing={2.5} color="gray.600" fontSize="xs">
                  <Icon as={MdSecurity} color="#162237" boxSize={4} />
                  <Text>100% Safe & Secure 256-bit Encrypted Payments</Text>
                </HStack>
                <HStack spacing={2.5} color="gray.600" fontSize="xs">
                  <Icon as={MdLocalShipping} color="#162237" boxSize={4} />
                  <Text>Reliable Express Courier Dispatch Across India</Text>
                </HStack>
              </VStack>
            </Box>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
}

export default Summary;